import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

async function getIncidentList(search, pageable) {
    console.log(">> 장애관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/maintenance/incident?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeIncidents(ids) {
    try {
        return await needAuth.put('/maintenance/incident/delete', ids);
    }catch (error){
        return error
    }
}

async function getIncident(id) {
    try {
        return await needAuth.get('/maintenance/incident/'+id);
    }catch (error){
        return error
    }
}

async function saveIncident(error, assets, handler, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    const assetData = assets?.map(item => ({id : item.id}));
    error.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    error.handlerIds = handlerIds;

    formData.append(
        "incidentRequestDto",
        new Blob([JSON.stringify(error)], { type: "application/json" })
    );

    return await needAuth.post(`/maintenance/incident/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
}

async function updateIncident(incident, assets, handler) {
    const assetData = assets?.map(item => ({id : item.id}));
    incident.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    incident.handlerIds = handlerIds;

    return await needAuth.post(`/maintenance/incident/update`, incident);
}

async function updateSingleIncident(data) {
    return await needAuth.put(`/maintenance/incident`, data);
}

const updateIncidentForInProgress = async (data, files) => {
    const formData = new FormData();
    files.forEach((file, index) => {formData.append(`files`, file.object);});
    formData.append("requestDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

    try {
        return await needAuth.put(
            `/maintenance/incident/inProgress`, formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
        )
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateIncidentForVerification = async (data) => {
    try {
        return await needAuth.put(`/maintenance/incident/verification`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


async function removeIncidentReport(id) {
    return await needAuth.put('/maintenance/incident/report/delete', id);
}

async function getIncidentReport(id) {
    return await needAuth.get('/maintenance/incident/report/'+id);
}

async function saveIncidentReport(incidentReport, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "incidentReportRequestDto",
        new Blob([JSON.stringify(incidentReport)], { type: "application/json" })
    );

    return await needAuth.post(`/maintenance/incident/report/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
}

async function updateIncidentReport(incident) {
    return await needAuth.post(`/maintenance/incident/report/update`, incident);
}


export {
    getIncidentList,
    removeIncidents,
    saveIncident,
    getIncident,
    updateIncident,
    updateSingleIncident,
    updateIncidentForInProgress,
    updateIncidentForVerification,
    removeIncidentReport,
    getIncidentReport,
    saveIncidentReport,
    updateIncidentReport
}